var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-wrapper"},[(_vm.bLabel)?_c('div',{staticClass:"label",style:({
      top: _vm.bTop - 10 + 'px',
      left: _vm.bLeft + 'px',
      width: _vm.bWidth + 4 + 'px',
    })},[_vm._v("\n    "+_vm._s(_vm.bLabel)+"\n  ")]):_vm._e(),(_vm.bActive)?_c('a',{staticClass:"box-delete",style:({
      top: _vm.bTop - 18 + 'px',
      left: _vm.bLeft + _vm.bWidth - 15 + 'px',
    }),on:{"click":_vm.removeMyself}},[_c('img',{attrs:{"src":require("@/assets/cross.svg"),"alt":""}})]):_vm._e(),_c('div',{staticClass:"box",class:{ active: _vm.bActive },style:({
      top: _vm.bTop + 'px',
      left: _vm.bLeft + 'px',
      width: _vm.bWidth + 'px',
      height: _vm.bHeight + 'px',
    }),on:{"mousedown":_vm.selectBox}})])
}
var staticRenderFns = []

export { render, staticRenderFns }